/* unplugin-vue-components disabled */import { render } from "./SvgIconCalendarWithBooks.vue?vue&type=template&id=4cd439d4"
import script from "./SvgIconCalendarWithBooks.vue?vue&type=script&lang=js"
export * from "./SvgIconCalendarWithBooks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__